import OrderCardItem from '~/app/components/order-list/common/OrderCardItem'
import styled from '~/app/components/styled'

/**
 * OrderListCardItem component
 * author: soojin.oh
 */

// styled components
const OrderListCardItem = styled(OrderCardItem)`
  ::after {
    content: '';
    border-bottom: 0.1rem solid ${({ theme }) => theme.color.gray200};
    position: relative;
    display: block;
    bottom: -2rem;
  }
  :nth-last-of-type(1) {
    ::after {
      content: none;
    }
  }
  @media (min-width: ${({ theme }) => theme.unit.PC_WIDTH}px) {
    width: calc(50% - 1rem);
    margin: 0;
    border-bottom: solid 1px ${({ theme }) => theme.color.gray200};
    display: flex;
    flex-direction: column;

    :nth-of-type(2n) {
      padding-right: 1rem;
      margin-right: 1rem;
    }

    :nth-of-type(2n - 1) {
      padding-left: 1rem;
      border-right: solid 0.1rem ${({ theme }) => theme.color.gray200};
      margin-left: 1rem;
    }

    :nth-last-of-type(1) {
      border-bottom: none;
    }

    :nth-last-of-type(2) {
      :nth-of-type(2n - 1) {
        border-bottom: none;
      }
    }

    ::after {
      content: none;
    }
  }
`

export default OrderListCardItem
